import { Badge, Box, Collapse, Divider, Flex, Text } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon, LinkIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { ApiService } from "./types";
import { STATUS_COLORS, STATUS_BG, STATUS_TEXT } from "./helpers";
import { EndpointGroupSection } from "./EndpointGroupSection";
import { BsGlobe } from "react-icons/bs";

export function ServiceCard({ service }: { service: ApiService }) {
  const [open, setOpen] = useState(false);

  const statusColor = STATUS_COLORS[service.status];
  const totalEndpoints = service.groups.reduce(
    (t, g) => t + g.endpoints.length,
    0
  );
  const isDeprecated = service.status === "Deprecated";

  return (
    <Box
      bg="white"
      borderRadius="10px"
      borderLeftWidth="4px"
      borderLeftColor={statusColor}
      border="1px solid"
      borderColor="gray.200"
      overflow="hidden"
      boxShadow="0 1px 3px rgba(0,0,0,0.06)"
    >
      {/* Card header */}
      <Flex
        align="center"
        px="20px"
        py="16px"
        cursor="pointer"
        _hover={{ bg: "gray.50" }}
        onClick={() => setOpen((v) => !v)}
        userSelect="none"
        gap="12px"
      >
        <Box
          w="32px"
          h="32px"
          borderRadius="10px"
          bg="gray.100"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
          fontSize="14px"
        >
          <LinkIcon color="var(--chakra-colors-primary-300)" />
        </Box>

        <Box flex={1} minW={0}>
          <Flex align="center" gap="8px" flexWrap="wrap">
            <Text
              fontWeight="700"
              fontSize="15px"
              color={isDeprecated ? "gray.400" : "#1E293B"}
              textDecoration={isDeprecated ? "line-through" : undefined}
            >
              {service.name}
            </Text>
            <Badge
              fontSize="10px"
              fontWeight="600"
              colorScheme="gray"
              variant="subtle"
              px="6px"
              py="2px"
            >
              {service.version}
            </Badge>
            <Badge
              fontSize="10px"
              fontWeight="700"
              bg={STATUS_BG[service.status]}
              color={STATUS_TEXT[service.status]}
              px="7px"
              py="2px"
              borderRadius="10px"
              opacity={isDeprecated ? 0.6 : 1}
            >
              {service.status.toUpperCase()}
            </Badge>
          </Flex>
          <Flex align="center" gap="6px" mt="4px">
            <Text fontSize="12px" color="gray.500">
              <BsGlobe color="var(--chakra-colors-primary-300)" />
            </Text>
            <Text fontSize="12px" color="gray.500" fontFamily="monospace">
              {service.baseUrl}
            </Text>
            <Text fontSize="12px" color="gray.400">
              ·
            </Text>
            <Text fontSize="12px" color="gray.500">
              {totalEndpoints} endpoint{totalEndpoints !== 1 ? "s" : ""}
            </Text>
          </Flex>
        </Box>

        <Box color="gray.400" flexShrink={0}>
          {open ? (
            <ChevronUpIcon boxSize="20px" />
          ) : (
            <ChevronDownIcon boxSize="20px" />
          )}
        </Box>
      </Flex>

      {/* Expanded content */}
      <Collapse in={open} animateOpacity>
        <Divider borderColor="gray.200" />
        <Box px="20px" py="16px">
          <Box mb="4px">
            <Text
              fontSize="11px"
              fontWeight="700"
              color="gray.500"
              textTransform="uppercase"
              letterSpacing="0.8px"
              mb="4px"
            >
              Descrição
            </Text>
            <Text fontSize="13px" color="gray.600">
              {service.description}
            </Text>
          </Box>
          {service.groups.map((group) => (
            <EndpointGroupSection key={group.tag} group={group} />
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
